import React, { useState } from "react";
import { Formik, Form, yupToFormErrors } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import * as Yup from "yup";
import { createMember } from "../../redux/actions/api/apiAction";
import moment from "moment";
import { store } from "../../redux/storeConfig/store";
import { NoteMemberDetails } from "../../views/pages/gymPortion/members/noteMemberDetails";
import { useSelector } from "react-redux";
import SpinnerComponent from "../spinner/spinner";
import DeletedMemberModal from "../../views/pages/gymPortion/members/deletedMemberDetailsModal";

const regEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// export const MultiStep = () => {
function MultiStepForMember({
  name,
  firstName,
  lastName,
  middleName,
  martialStatus,
  homeAddress,
  street,
  occupation,
  companyName,
  emergencyName,
  emergencyPhone,
  email,
  phone,
  gender,
  activeStatus,
  handleSubmit,
  handleSubmitForUpdate,
  edit,
  dob,
  image,
  id,
  packages,
  verifiyedUsing,
  RFIDCardIdField,
  verifyBy,
  metaData,
}) {
  const { features, gymFeaturesObject } = useSelector(
    (state) => state.features
  );
  const { loading, gym, gymConfig } = useSelector((state) => state.gym);
  const { settings } = useSelector((state) => state.gym.gym);

  const [step, setStep] = useState(1);
  const [numberOfRelations, setNumberOfRelations] = useState(0);
  const [relations, setRelations] = React.useState([]);
  const [additionalInfoErrors, setAdditionalInfoErrors] = useState({});

  const memberFieldsRequiredMessages = {
    image: "image profile is required",
    middleName: "Middle name is required",
    martialStatus: "Marital status is required",
    homeAddress: "Home address is required",
    occupation: "Occupation is required",
    companyName: "Company name is required",
    emergencyName: "Emergency name is required",
    emergencyPhone: "Emergency phone is required",
    email: "Email address is required",
    phone: "Phone number is required",
    healthProblem: "Health problem is required",
  };
  // handleSubmitForUpdate = async (values) => {
  //   //console.log('Member Form Update', values);
  //   await store.dispatch(updateMember(values));
  // };
  const validateAdditionalInfo = (values) => {
    let canSubmit = true;
    let errorMessages = {};

    //validate image
    if (settings?.memberRegistration?.profilePictureRequired && !values.image) {
      canSubmit = false;
      errorMessages["image"] = memberFieldsRequiredMessages["image"];
    }
    //validate middleName
    if (settings?.memberRegistration?.fields?.middleName?.enabled && settings?.memberRegistration?.fields?.middleName?.isRequired && !values.middleName) {
      canSubmit = false;
      errorMessages["middleName"] = memberFieldsRequiredMessages["middleName"];
    }
    //validate maritalStatus
    if (settings?.memberRegistration?.fields?.maritalStatus?.enabled && settings?.memberRegistration?.fields?.maritalStatus?.isRequired && !values.martialStatus) {
      canSubmit = false;
      errorMessages["martialStatus"] = memberFieldsRequiredMessages["martialStatus"];
    }
    //validate homeAddress
    if (settings?.memberRegistration?.fields?.homeAddress?.enabled && settings?.memberRegistration?.fields?.homeAddress?.isRequired && !values.homeAddress) {
      canSubmit = false;
      errorMessages["homeAddress"] = memberFieldsRequiredMessages["homeAddress"];
    }
    //validate jobTitle
    if (settings?.memberRegistration?.fields?.jobTitle?.enabled && settings?.memberRegistration?.fields?.jobTitle?.isRequired && !values.occupation) {
      canSubmit = false;
      errorMessages["occupation"] = memberFieldsRequiredMessages["occupation"];
    }
    //validate companyName
    if (settings?.memberRegistration?.fields?.companyName?.enabled && settings?.memberRegistration?.fields?.companyName?.isRequired && !values.companyName) {
      canSubmit = false;
      errorMessages["companyName"] = memberFieldsRequiredMessages["companyName"];
    }
    //validate emergencyContact
    if (settings?.memberRegistration?.fields?.emergencyContact?.enabled && settings?.memberRegistration?.fields?.emergencyContact?.isRequired && (!values.emergencyName || !values.emergencyPhone)) {
      if (!values.emergencyName) {
        canSubmit = false;
        errorMessages["emergencyName"] = memberFieldsRequiredMessages["emergencyName"];
      }
      if (!values.emergencyPhone) {
        canSubmit = false;
        errorMessages["emergencyPhone"] = memberFieldsRequiredMessages["emergencyPhone"];
      }
    }
    //validate primaryField > "emailOrPhone"
    if (settings?.memberRegistration?.primaryField == "emailOrPhone" && !values.email && !values.phone) {
      canSubmit = false;
      errorMessages["email"] = memberFieldsRequiredMessages["email"];
      errorMessages["phone"] = memberFieldsRequiredMessages["phone"];
    }
    //validate primaryField > "emailAndPhone"
    if (settings?.memberRegistration?.primaryField == "emailAndPhone" && (!values.email || !values.phone)) {
      if (!values.email) {
        canSubmit = false;
        errorMessages["email"] = memberFieldsRequiredMessages["email"];
      }
      if (!values.phone) {
        canSubmit = false;
        errorMessages["phone"] = memberFieldsRequiredMessages["phone"];
      }
    }
    //validate healthProblem
    if (settings?.memberRegistration?.fields?.healthProblem?.enabled && settings?.memberRegistration?.fields?.healthProblem?.isRequired && !values.healthProblem) {
      canSubmit = false;
      errorMessages["healthProblem"] = memberFieldsRequiredMessages["healthProblem"];
    }

    if (!canSubmit) {
      setAdditionalInfoErrors(errorMessages);
    } else {
      setAdditionalInfoErrors({});
    }
    return canSubmit;
  };
  
  handleSubmit = async (values, { setErrors, errors }) => {
    // debugger;
    if (gymConfig?.gates?.enabled && gymConfig?.gates?.accessBy == "RFIDCards") {
      if (!values.RFIDCardIdField) {
        return;
      } else {
        values.cardMembershipId = values.RFIDCardIdField;
      }
    }

    if (!validateAdditionalInfo(values)) {
      return;
    }

    

    await store.dispatch(
      createMember({
        ...values,
        verifyBy: !settings?.memberRegistration?.fields?.verificationBy?.enabled ? false : values.verifyBy,
        smsGateway: gym?.smsGateway,
        superGymAdmin: gym?.superGymAdmin,
      })
    );
  };

  const submit = (values, { setErrors }) => {
    if (edit) {
      handleSubmitForUpdate(values);
    } else {
      handleSubmit(values, { setErrors });
    }
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = Yup.object().shape({
    image: Yup.string(),
    firstName: Yup.string().required("First Name is required"),
    phone: Yup.string().matches(
      new RegExp("[0-9]{12}"),
      "Phone number is not valid"
    ),
    // .required("Please enter valid phone number"),
    email: Yup.string().email("Please enter valid Username i.e email"),
    // .required("Email is required"),
    dob: Yup.date(),
    gender: Yup.string().required("Gender is required"),
    relationOpen: Yup.boolean(),
    relations: Yup.array()
      .of(
        Yup.object().shape({
          firstName: Yup.string().required(
            "Family member first name is required"
          ),

          gender: Yup.string().required("Family member gender is required"),

          relation: Yup.string().required("Family relation is required"),
          dob: Yup.string().required("Date of birth is required"),
          accountType: Yup.string(),
        })
      )
      .min(
        numberOfRelations,
        "Please fill all relation fields or close the relation section "
      ),

    // activeStatus: Yup.string().required('Status is required'),
  });

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          name,
          firstName,
          middleName,
          martialStatus,
          homeAddress,
          street,
          occupation,
          companyName,
          emergencyName,
          emergencyPhone,
          lastName,
          email,
          phone,
          gender,
          activeStatus,
          image,
          dob,
          relations: [],
          accountType: "primary",
          id,
          verifiyedUsing,
          cardMembershipId: "",
          RFIDCardIdField,
          verifyBy,
          healthProblem: metaData?.healthProblem || "",
          medicalHistory: metaData?.medicalHistoryData || {},
          handedness: metaData?.handedness || [],
          smokingHabits: metaData?.smokingHabits || [],
          referralSource: metaData?.referralSource || "",
          insuranceDetails: metaData?.insuranceDetails || {},
          referralNote:metaData?.referralSource?.referralNote||""
        }}
        onSubmit={(values, { setErrors }) => {
          submit(values, { setErrors });
        }}
        validationSchema={formSchema1}
      >
        {({
          errors,
          touched,
          values,
          setFieldValue,
          setErrors,
          handleBlur,
          setFieldTouched,
        }) => (
          <Form>
            <FormFirstStep
              relations={relations}
              setRelations={setRelations}
              setErrors={setErrors}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldTouched={setFieldTouched}
              values={values}
              setFieldValue={setFieldValue}
              setNumberOfRelations={setNumberOfRelations}
              numberOfRelations={numberOfRelations}
              packages={packages}
              additionalInfoErrors={additionalInfoErrors}
              validateAdditionalInfo={validateAdditionalInfo}
            />

            <StepButton step={step} previous={previous} edit={edit} />
          </Form>
        )}
      </Formik>
      <NoteMemberDetails />
      <DeletedMemberModal/>
    </>
  );
}
MultiStepForMember.defaultProps = {
  name: "",
  firstName: "",
  middleName: "",
  martialStatus: "",
  homeAddress: "",
  street: "",
  occupation: "",
  companyName: "",
  emergencyName: "",
  lastName: "",
  emergencyPhone: "",
  email: "",
  phone: "",
  dob: "",
  id: "",
  handleSubmit: (values) => {
  },
  edit: false,
  type: "",
  image: "",
  gender: "",
  relations: [],
  accountType: "primary",
  cardMembershipId: "",
  RFIDCardIdField: "",
  verifyBy: "phone",
  metaData: {},
  // handleSubmitForUpdate: (values) => {
  //   //console.log(values, 'values here');
  // },
};

export default MultiStepForMember;
